import React from "react";
import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarQuickFilter } from "@mui/x-data-grid";
import "../../static/css/catalogManagement.css";

export const CatalogHeader = ({ title, description, count, actions }) => (
  <header className="catalog-header">
    <div><span className="catalog-eyebrow">GRACE • CATALOGUE</span><h1>{title}</h1><p>{description}</p>
      {count != null && <span className="catalog-count">{Number(count).toLocaleString("en-IN")} matching records</span>}
    </div>
    <div className="catalog-header-actions">{actions}</div>
  </header>
);

export const CatalogToolbar = () => (
  <GridToolbarContainer className="catalog-toolbar">
    <GridToolbarQuickFilter debounceMs={400} quickFilterParser={(value) => value.trim() ? [value.trim()] : []}
      placeholder="Search by name or code…" aria-label="Search catalogue records" />
    <div className="catalog-tools"><GridToolbarColumnsButton /><GridToolbarDensitySelector />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} /></div>
  </GridToolbarContainer>
);

export const CatalogStatus = ({ active, onClick }) => (
  <button type="button" className={active ? "catalog-status active" : "catalog-status inactive"}
    onClick={onClick} title={onClick ? "Click to change status" : undefined}>
    <span />{active ? "Active" : "Inactive"}
  </button>
);
